export default __webpack_public_path__ + "static/media/rocket-blue.4b1fa60f.svg";